import React, { useEffect, useState } from 'react';
import { Box, List, ListItem, Divider, Typography } from '@material-ui/core';
import QBookmarkItem from './QBookmarkItem';
import QBookmarksForm from './QBookmarksForm';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';

const SaaSqBookmarks = ({ qAppPromise, title, height }) => {
    const [loading, setLoading] = useState(true);
    const [bookmarksList, setBookmarksList] = useState(null);
    const [error, setError] = useState(null);

    const getBookmarksList = async () => {
        setLoading(true);
        const result = await qAppPromise
            .getList('BookmarkList')
            .catch((err) => {
                console.error('Failed to load bookmarks', err);
                setError(err);
            });

        if (result) {
            setBookmarksList(result.layout.qBookmarkList.qItems);
        }
        setLoading(false);
    };

    const handleApplyBookmark = async (id) => {
        await qAppPromise.bookmark.apply(id).catch((err) => {
            console.error('Failed to apply bookmarks', err);
            setError(err);
        });
    };

    const handleDeleteBookmark = async (id) => {
        const deletedBookmark = await qAppPromise.bookmark
            .remove(id)
            .catch((err) => {
                console.error('Failed to delete bookmarks', err);
                setError(err);
            });

        if (deletedBookmark) {
            const bookmarks = bookmarksList.filter(
                ({ qInfo }) => qInfo.qId !== id
            );
            setBookmarksList(bookmarks);
        }
    };

    const handleCreateBookmark = async ({ title, description }) => {
        const createdBookmark = await qAppPromise.bookmark
            .create(title, description)
            .catch((err) => {
                console.error('Failed to create bookmarks', err);
                setError(err);
            });
        if (createdBookmark) {
            getBookmarksList();
        }
    };

    useEffect(() => {
        getBookmarksList();
    }, []);

    if (loading) {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <Skeleton variant={'rect'} height={height} width="100%" />
            </div>
        );
    }

    return (
        <Box>
            <List component="nav" aria-label="Bookmarks">
                <ListItem>
                    <Typography variant="h6">Create Bookmark</Typography>
                </ListItem>
                <Divider />
                <QBookmarksForm handleCreateBookmark={handleCreateBookmark} />
                <Divider />

                <ListItem>
                    <Typography variant="h6">{title || 'Bookmarks'}</Typography>
                </ListItem>
                <Divider />
                {bookmarksList.length > 0 ? (
                    bookmarksList.map((bookmark) => (
                        <QBookmarkItem
                            key={bookmark.qInfo.qId}
                            qBookmark={bookmark}
                            handleDeleteBookmark={handleDeleteBookmark}
                            handleApplyBookmark={handleApplyBookmark}
                        />
                    ))
                ) : (
                    <ListItem>No bookmarks found</ListItem>
                )}
            </List>
        </Box>
    );
};

SaaSqBookmarks.propTypes = {
    title: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    qAppPromise: PropTypes.object.isRequired,
};

export default SaaSqBookmarks;
